var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuiSliderThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2756_23321)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2756_23321",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 13C6 8.02944 10.0294 4 15 4C19.9706 4 24 8.02944 24 13C24 17.9706 19.9706 22 15 22C10.0294 22 6 17.9706 6 13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 13C6 8.02944 10.0294 4 15 4C19.9706 4 24 8.02944 24 13C24 17.9706 19.9706 22 15 22C10.0294 22 6 17.9706 6 13Z",
    fill: "#0046B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13M24 13M24 13M6 13M15 4M24 13M15 22M6 13M15 22V20C11.134 20 8 16.866 8 13H6H4C4 19.0751 8.92487 24 15 24V22ZM24 13H22C22 16.866 18.866 20 15 20V22V24C21.0751 24 26 19.0751 26 13H24ZM15 4V6C18.866 6 22 9.13401 22 13H24H26C26 6.92487 21.0751 2 15 2V4ZM15 4V2C8.92487 2 4 6.92487 4 13H6H8C8 9.13401 11.134 6 15 6V4Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2756_23321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2756_23321",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.25098 0 0 0 0 0.686275 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2756_23321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2756_23321",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuiSliderThumb);
export default __webpack_public_path__ + "static/media/MuiSliderThumb.faea25a43104611bd33d1d20de696b2f.svg";
export { ForwardRef as ReactComponent };